import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";
import { Link } from "gatsby";

class LoanCalculatorResults extends Component {
  static propTypes = {
    loanCalculationResults: PropTypes.object.isRequired,
    pageContent: PropTypes.object.isRequired,
    onCloseResults: PropTypes.func.isRequired
  };

  render() {
    const { loanCalculationResults, pageContent, onCloseResults } = this.props;

    return (
      <div className="col-md-5 col-xl-4 col-lg-5 col-sm-12 details-panel">
        <div className="row">
          <div
            className="col-12 mm-loan-hide-result d-block d-md-none"
            onClick={onCloseResults}
          >
            <span className="mm-event-hide-result">
              &lt;{pageContent.detailsPanel.backButtonText}
            </span>
          </div>
          <div className="col-12 text-center">
            <div className="mm-loan-calculator-result text-center">
              <img src={pageContent.images.moneyBag} />
              <div className="mm-price-value">
                <NumberFormat
                  prefix="€"
                  value={
                    loanCalculationResults.maxLoanAmount
                      ? loanCalculationResults.maxLoanAmount
                      : loanCalculationResults.monthlyLoanAmount
                  }
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </div>
              <div className="mm-notice">{pageContent.detailsPanel.hero}</div>
            </div>
          </div>
          <div className="mm-mt-50">
            <div className="col-12">
              <div className="mm-lines">
                <span>{pageContent.detailsPanel.subtitle1}</span>
                <div className="float-right d-inline-block">
                  <NumberFormat
                    suffix="€"
                    value={
                      loanCalculationResults.maxMonthlyAmount
                        ? loanCalculationResults.maxMonthlyAmount
                        : loanCalculationResults.repaymentAmount
                    }
                    displayType="text"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="mm-lines">
                <span>{pageContent.detailsPanel.subtitle2}</span>
                <div className="float-right d-inline-block">
                  <NumberFormat
                    suffix={loanCalculationResults.maxLoanDuration ? null : "€"}
                    value={
                      loanCalculationResults.maxLoanDuration
                        ? loanCalculationResults.maxLoanDuration
                        : loanCalculationResults.loanCost
                    }
                    displayType="text"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={0}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="position-relative">
              <div className="d-flex h-100 align-items-center position-absolute">
                <span className="mm-info-icon align-middle">
                  <img src={pageContent.images.info} />
                </span>
              </div>
              <p className="mm-info">{pageContent.detailsPanel.info}</p>
            </div>
          </div>
          <div className="col-12">
            <div className="mm-compare-link">
              <Link
                to={pageContent.detailsPanel.linkUrl}
                {...(pageContent.detailsPanel.linkUrlWithState || {})}
              >
                {pageContent.detailsPanel.linkText}
                <span className="pl-1">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoanCalculatorResults;
